import IntroPanel from "./IntroPanel";
export default IntroPanel;
